var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_216_",
    className: "st0",
    d: "M14.4,23.8H1.3V8.6h18.7v3.2c0,0.2,0.1,0.4,0.3,0.4h0.7c0.2,0,0.3-0.2,0.3-0.4V3.6 c0-0.8-0.6-1.4-1.3-1.4h-3.3V0.4c0-0.2-0.1-0.4-0.3-0.4h-0.7c-0.2,0-0.3,0.2-0.3,0.4v1.8H6V0.4C6,0.2,5.9,0,5.7,0H5 C4.8,0,4.7,0.2,4.7,0.4v1.8H1.3C0.6,2.2,0,2.8,0,3.6v20.2c0,0.8,0.6,1.4,1.3,1.4h13.1c0.2,0,0.3-0.2,0.3-0.4v-0.7 C14.7,23.9,14.6,23.8,14.4,23.8z M1.3,3.6H5h0.7h10h0.7h3.7v3.6H1.3V3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_217_",
    className: "st0",
    d: "M8,13.3C8,13.1,7.9,13,7.7,13H5c-0.2,0-0.3,0.2-0.3,0.4V14c0,0.2,0.1,0.4,0.3,0.4h2.7 C7.9,14.4,8,14.2,8,14V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_218_",
    className: "st0",
    d: "M10.4,13c-0.2,0-0.3,0.2-0.3,0.4V14c0,0.2,0.1,0.4,0.3,0.4h2.7c0.2,0,0.3-0.2,0.3-0.4v-0.7 c0-0.2-0.1-0.4-0.3-0.4H10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_219_",
    className: "st0",
    d: "M7.7,16.6H5c-0.2,0-0.3,0.2-0.3,0.4v0.7C4.7,17.8,4.8,18,5,18h2.7C7.9,18,8,17.8,8,17.6v-0.7 C8,16.7,7.9,16.6,7.7,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_222_",
    className: "st0",
    d: "M20.1,13.6c-3.3,0-5.9,2.8-5.9,6.2s2.7,6.2,5.9,6.2s5.9-2.8,5.9-6.2S23.3,13.6,20.1,13.6z  M20.1,24.6c-2.5,0-4.6-2.1-4.6-4.8s2.1-4.8,4.6-4.8s4.6,2.1,4.6,4.8S22.6,24.6,20.1,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    className: "st0",
    d: "M20.5,19.8v-2.2c0-0.2-0.1-0.4-0.3-0.4h-0.7c-0.2,0-0.3,0.2-0.3,0.4v2.9l2.2,2 c0.1,0.1,0.4,0.1,0.5,0l0.4-0.5c0.1-0.2,0.1-0.4,0-0.5L20.5,19.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/Datepicker.0a6baf00c2b5735c1a42ca20c99af498.svg";
export { ForwardRef as ReactComponent };